export interface FilterInput {
  search: string;
}
